import { ReactElement, useState } from 'react';

import PasswordResetSuccessfully from '../password-reset-successfully';
import ResetPassword from '../reset-password';

type StepType = {
  index: number;
  component: ReactElement;
};

const ForgotPasswordStepper = () => {
  const INITIAL_STEP = 0;

  const [currentStepIndex, setCurrentStepIndex] = useState(INITIAL_STEP);

  const handleGoToStep = (index: number) => {
    setCurrentStepIndex(index);
  };

  const AVAILABLE_STEPS: StepType[] = [
    {
      index: 0,
      component: <ResetPassword goToStep={handleGoToStep} />,
    },
    {
      index: 1,
      component: <PasswordResetSuccessfully />,
    },
  ];

  const step = AVAILABLE_STEPS[currentStepIndex] ?? AVAILABLE_STEPS[0];

  return step.component;
};

export default ForgotPasswordStepper;
